// extracted by mini-css-extract-plugin
export default {"form":"CapacityDialog_form__lYRKz","helpHeader":"CapacityDialog_helpHeader__2ArvH"};